export default "__VITE_ASSET__C2eKg_Zx__"